/**
 * Auth store — Task 32.3
 * JWT in memory; refresh token in httpOnly cookie (server-managed).
 */
import { create } from 'zustand'
import { setAccessToken } from '@/lib/api'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  setUser: (user: User | null) => void
  setToken: (token: string | null) => void
  setLoading: (loading: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  setUser: (user) =>
    set({ user, isAuthenticated: !!user, isLoading: false }),

  setToken: (token) => {
    setAccessToken(token)
    if (!token) {
      set({ user: null, isAuthenticated: false, isLoading: false })
    }
  },

  setLoading: (loading) =>
    set({ isLoading: loading }),

  logout: () => {
    setAccessToken(null)
    set({ user: null, isAuthenticated: false, isLoading: false })
  },
}))
